/* Protees Noir — quick add, cart drawer, homepage motion, product page */
(function () {
  'use strict';
  if (window.Noir) return;
  var cfg = window.NoirConfig || {};
  var ROOT = (cfg.root || '/').replace(/\/?$/, '/');
  var FREE = Number(cfg.free) || 300000;
  var FEE = Number(cfg.fee) || 25000;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
  var clean = function (s) { return String(s || '').split('NEWURG')[0].trim().toLowerCase(); };

  function money(cents) {
    var n = (Number(cents) || 0) / 100;
    var fmt = cfg.money || 'Rs.{{amount_no_decimals}}';
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
      if (k.indexOf('no_decimals') > -1) return Math.round(n).toLocaleString('en-US');
      if (k.indexOf('comma') > -1) return n.toFixed(2).replace('.', ',');
      var s = n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      return s.replace(/\.00$/, '');
    });
  }
  var SZ = { 'SMALL': 'S', 'MEDIUM': 'M', 'LARGE': 'L', 'X-LARGE': 'XL', 'XLARGE': 'XL', 'EXTRA LARGE': 'XL', 'XX-LARGE': 'XXL', 'XXLARGE': 'XXL', '2XL': 'XXL', 'XXX-LARGE': '3XL', 'XXXLARGE': '3XL', '3XL': '3XL', 'X-SMALL': 'XS', 'XSMALL': 'XS', 'EXTRA SMALL': 'XS', 'XX-SMALL': 'XXS', 'MED': 'M', 'SM': 'S', 'LG': 'L' };
  var lab = function (v) {
    var u = String(v || '').toUpperCase().replace(/\s*\(.*?\)\s*/g, ' ').replace(/\s+/g, ' ').trim();
    if (SZ[u]) return SZ[u];
    var c = u.replace(/[\s-]/g, '');
    if (SZ[c]) return SZ[c];
    return /^(XXS|XS|S|M|L|XL|XXL|3XL)$/.test(u) ? u : v;
  };

  /* ---------- size charts ---------- */
  var charts = (cfg.charts || []).map(function (c) {
    var cols = String(c.cols || '').split('|').map(function (x) { return x.trim(); });
    var rows = String(c.rows || '').split(/<br\s*\/?>/i).map(function (r) { return r.split('|').map(function (x) { return x.trim(); }); }).filter(function (r) { return r[0]; });
    return { m: String(c.m || '').split(',').map(function (x) { return x.trim(); }).filter(Boolean), cols: cols, rows: rows, unit: c.unit || 'in' };
  });
  var SPECIAL = /\b(kids?|junior|boys?|girls?|ladies|lady|women|womens|woman)\b/;
  function chartFor(text) {
    text = String(text || '').toLowerCase();
    var special = SPECIAL.test(text);
    for (var i = 0; i < charts.length; i++) {
      /* words starting with ! exclude a chart, e.g. "trouser, !shorts" */
      var skip = charts[i].m.some(function (w) { return w.charAt(0) === '!' && text.indexOf(w.slice(1)) > -1; });
      if (skip) continue;
      for (var j = 0; j < charts[i].m.length; j++) {
        if (charts[i].m[j].charAt(0) === '!') continue;
        if (text.indexOf(charts[i].m[j]) > -1) {
          /* a men's chart must not be shown on ladies or kids products */
          if (special && !SPECIAL.test(charts[i].m.join(' ')) && !/crop/.test(charts[i].m.join(' '))) continue;
          return charts[i];
        }
      }
    }
    return null;
  }
  function rowFor(chart, size) {
    if (!chart) return null;
    var s = lab(size);
    for (var i = 0; i < chart.rows.length; i++) if (lab(chart.rows[i][0]) === s) return chart.rows[i];
    return null;
  }
  function conv(val, from, to) {
    if (from === to) return val;
    return String(val).replace(/\d+(\.\d+)?/g, function (n) {
      var x = from === 'in' ? parseFloat(n) * 2.54 : parseFloat(n) / 2.54;
      return (Math.round(x * 2) / 2).toString();
    });
  }
  var unitSym = function (u) { return u === 'cm' ? ' cm' : '"'; };

  /* ---------- cart api ---------- */
  function api(path, body) {
    var opts = { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' };
    if (body) { opts.method = 'POST'; opts.headers['Content-Type'] = 'application/json'; opts.body = JSON.stringify(body); }
    return fetch(ROOT + path, opts).then(function (r) {
      return r.json().then(function (j) { if (!r.ok) throw j; return j; });
    });
  }
  var Cart = {
    state: null,
    get: function () { return api('cart.js').then(function (c) { Cart.state = c; return c; }); },
    add: function (id, q) { return api('cart/add.js', { items: [{ id: Number(id), quantity: q || 1 }] }); },
    change: function (key, q) { return api('cart/change.js', { id: key, quantity: q }).then(function (c) { Cart.state = c; return c; }); }
  };

  /* ---------- header bag count ---------- */
  function cartLinks() { return $$('.js-drawer-open-cart, a[href$="/cart"].site-nav__link'); }
  function setCount(n, bump) {
    document.documentElement.classList.add('noir-has-count');
    cartLinks().forEach(function (a) {
      var holder = $('.cart-link', a) || a;
      var b = $('.nb-count', holder);
      if (!b) { b = document.createElement('span'); b.className = 'nb-count'; holder.appendChild(b); }
      b.textContent = n > 99 ? '99+' : n;
      b.classList.toggle('is-on', n > 0);
      var bub = $('.cart-link__bubble', holder); if (bub) bub.classList.toggle('cart-link__bubble--visible', n > 0);
      if (bump && !reduce) {
        [holder, b].forEach(function (el) { el.classList.remove('nb-bump'); void el.offsetWidth; el.classList.add('nb-bump'); });
      }
    });
  }
  function visibleCartIcon() {
    var links = cartLinks();
    for (var i = 0; i < links.length; i++) { var r = links[i].getBoundingClientRect(); if (r.width && r.bottom > 0 && r.top < innerHeight) return links[i]; }
    return null;
  }

  /* ---------- fly to bag ---------- */
  function fly(src, fromRect) {
    return new Promise(function (done) {
      var target = visibleCartIcon();
      if (reduce || !src || !fromRect || !target || !Element.prototype.animate) return done();
      var tr = target.getBoundingClientRect();
      var size = Math.min(fromRect.width, fromRect.height, 160);
      var x0 = fromRect.left + fromRect.width / 2 - size / 2, y0 = fromRect.top + fromRect.height / 2 - size / 2;
      var img = document.createElement('img');
      img.src = src; img.alt = ''; img.className = 'n-fly';
      img.style.cssText = 'left:' + x0 + 'px;top:' + y0 + 'px;width:' + size + 'px;height:' + size * 1.2 + 'px';
      document.body.appendChild(img);
      var dx = tr.left + tr.width / 2 - (x0 + size / 2), dy = tr.top + tr.height / 2 - (y0 + size * 0.6);
      var a = img.animate([
        { transform: 'translate(0,0) scale(1) rotate(0)', opacity: 1 },
        { transform: 'translate(' + dx * 0.35 + 'px,' + (Math.min(dy * 0.3, 0) - 90) + 'px) scale(.62) rotate(-6deg)', opacity: 1, offset: 0.45 },
        { transform: 'translate(' + dx + 'px,' + dy + 'px) scale(.12) rotate(-16deg)', opacity: 0.35 }
      ], { duration: 780, easing: 'cubic-bezier(.55,.05,.45,1)', fill: 'forwards' });
      a.onfinish = function () { img.remove(); done(); };
      setTimeout(function () { if (img.parentNode) { img.remove(); done(); } }, 1200);
    });
  }

  /* ---------- scroll lock + focus ---------- */
  var lastFocus = null, openCount = 0;
  function lock(on) { openCount = Math.max(0, openCount + (on ? 1 : -1)); document.documentElement.classList.toggle('noir-lock', openCount > 0); }

  /* ---------- drawer ---------- */
  var Drawer = {
    el: null, open: false, upsFor: null,
    init: function () {
      this.el = $('#NoirDrawer'); if (!this.el) return;
      var self = this;
      this.el.addEventListener('click', function (e) {
        if (e.target.closest('[data-nd-close]')) { self.hide(); return; }
        var q = e.target.closest('[data-nd-q]');
        if (q) { var row = q.closest('[data-key]'); self.qty(row, Number(q.getAttribute('data-nd-q'))); return; }
        var up = e.target.closest('[data-nd-up]');
        if (up) { e.preventDefault(); self.upsell(up); }
      });
    },
    show: function () {
      if (!this.el) return;
      if (!this.open) { lastFocus = document.activeElement; lock(true); }
      this.open = true;
      this.el.classList.add('is-open'); this.el.setAttribute('aria-hidden', 'false');
      var p = $('.nd-panel', this.el); setTimeout(function () { p.focus({ preventScroll: true }); }, 60);
    },
    hide: function () {
      if (!this.el || !this.open) return;
      this.open = false; lock(false);
      this.el.classList.remove('is-open'); this.el.setAttribute('aria-hidden', 'true');
      if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
    },
    refresh: function (newKey) { var self = this; return Cart.get().then(function (c) { self.render(c, newKey); return c; }); },
    render: function (c, newKey) {
      if (!this.el) return;
      var items = c.items || [];
      var count = c.item_count || 0;
      setCount(count, !!newKey);
      $('[data-nd-count]', this.el).textContent = '(' + count + ')';
      this.el.classList.toggle('is-empty', !items.length);
      $('[data-nd-empty]', this.el).hidden = !!items.length;
      var sub = c.total_price || 0, left = Math.max(0, FREE - sub);
      $('[data-nd-shipmsg]', this.el).innerHTML = left > 0 ? 'You are <b>' + money(left) + '</b> away from <b>FREE shipping</b>' : 'You have unlocked <b>FREE shipping</b>';
      var bar = $('[data-nd-bar]', this.el);
      requestAnimationFrame(function () { bar.style.width = Math.min(100, sub / FREE * 100) + '%'; });
      $('[data-nd-fee]', this.el).textContent = !items.length ? '—' : (left > 0 ? money(FEE) : 'FREE');
      $('[data-nd-total]', this.el).textContent = money(sub + (items.length && left > 0 ? FEE : 0));
      $('[data-nd-items]', this.el).innerHTML = items.map(function (it) {
        var img = it.image ? it.image + (it.image.indexOf('?') > -1 ? '&' : '?') + 'width=200' : '';
        var vt = (it.options_with_values || []).map(function (o) { return (/size/i.test(o.name) ? 'Size ' : o.name + ' ') + lab(o.value); }).join(' · ');
        if (it.product_has_only_default_variant) vt = '';
        var was = it.original_line_price > it.final_line_price ? '<s>' + money(it.original_line_price) + '</s>' : '';
        return '<div class="nd-item' + (it.key === newKey ? ' is-new' : '') + '" data-key="' + esc(it.key) + '" data-q="' + it.quantity + '">' +
          '<a class="nd-item__img" href="' + esc(it.url) + '">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy">' : '') + '</a>' +
          '<div class="nd-item__b"><div class="nd-item__r1"><a class="nd-item__t" href="' + esc(it.url) + '">' + esc(clean(it.product_title)) + '</a><div class="nd-item__p">' + money(it.final_line_price) + was + '</div></div>' +
          (vt ? '<div class="nd-item__v">' + esc(vt) + '</div>' : '') +
          '<div class="nd-item__r2"><div class="nd-qty"><button type="button" data-nd-q="-1" aria-label="Decrease quantity">−</button><span>' + it.quantity + '</span><button type="button" data-nd-q="1" aria-label="Increase quantity">+</button></div>' +
          '<button type="button" class="nd-rm" data-nd-q="0">Remove</button></div></div></div>';
      }).join('');
      if (cfg.upsell !== false && items.length) this.loadUpsell(items[0].product_id, items); else $('[data-nd-ups]', this.el).hidden = true;
    },
    qty: function (row, d) {
      if (!row) return;
      var self = this, q = Number(row.getAttribute('data-q'));
      var nq = d === 0 ? 0 : Math.max(0, q + d);
      row.classList.add('is-busy');
      Cart.change(row.getAttribute('data-key'), nq).then(function (c) { self.render(c); sync(); })
        .catch(function (e) { row.classList.remove('is-busy'); alert((e && e.description) || 'Could not update the bag.'); });
    },
    upsCache: {},
    loadUpsell: function (pid, items) {
      var self = this, box = $('[data-nd-ups]', this.el), row = $('[data-nd-ups-row]', this.el);
      var inCart = {}; items.forEach(function (i) { inCart[i.product_id] = 1; });
      var draw = function (list) {
        list = (list || []).filter(function (p) { return p.available && !inCart[p.id]; }).slice(0, 4);
        if (!list.length) { box.hidden = true; return; }
        self.upsList = list;
        row.innerHTML = list.map(function (p, i) {
          var img = p.featured_image ? p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=120' : '';
          return '<div class="nd-up"><a class="nd-up__img" href="' + esc(p.url) + '">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy">' : '') + '</a>' +
            '<div style="min-width:0"><div class="nd-up__t">' + esc(clean(p.title)) + '</div><div class="nd-up__p">' + money(p.price) + '</div></div>' +
            '<button type="button" data-nd-up="' + i + '" aria-label="Add ' + esc(clean(p.title)) + '">+</button></div>';
        }).join('');
        box.hidden = false;
      };
      if (this.upsCache[pid]) return draw(this.upsCache[pid]);
      fetch(ROOT + 'recommendations/products.json?product_id=' + pid + '&limit=8', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (j) { self.upsCache[pid] = j.products || []; draw(self.upsCache[pid]); })
        .catch(function () { box.hidden = true; });
    },
    upsell: function (btn) {
      var p = this.upsList && this.upsList[Number(btn.getAttribute('data-nd-up'))]; if (!p) return;
      if (p.variants.length === 1 || (p.options && p.options.length > 1)) {
        if (p.options && p.options.length > 1) { location.href = p.url; return; }
        btn.disabled = true; btn.textContent = '…';
        var self = this;
        Cart.add(p.variants[0].id).then(function (r) { self.refresh(r.items && r.items[0] && r.items[0].key); sync(); })
          .catch(function (e) { btn.disabled = false; btn.textContent = '+'; alert((e && e.description) || 'Sold out'); });
        return;
      }
      Sheet.open({
        id: p.id, t: clean(p.title), u: p.url, img: p.featured_image ? p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=300' : '',
        cat: p.type, type: (p.type || '') + ' ' + p.title, p: p.price, c: p.compare_at_price || 0,
        v: p.variants.map(function (v) { return [v.id, v.option1, v.available]; })
      }, null, true);
    }
  };
  function sync() { try { document.dispatchEvent(new CustomEvent('cart:build')); } catch (e) {} }

  /* ---------- add flow ---------- */
  function addFlow(id, opts) {
    opts = opts || {};
    var btn = opts.btn;
    var setBtn = function (s) { if (!btn) return; btn.classList.toggle('is-loading', s === 'loading'); btn.classList.toggle('is-done', s === 'done'); };
    setBtn('loading');
    if (opts.card) opts.card.classList.add('is-busy');
    var t0 = Date.now();
    return Cart.add(id, opts.qty).then(function (res) {
      var key = res.items && res.items[0] && res.items[0].key;
      var wait = Math.max(0, 450 - (Date.now() - t0));
      return new Promise(function (r) { setTimeout(r, wait); }).then(function () {
        setBtn('done');
        return new Promise(function (r) { setTimeout(r, 380); });
      }).then(function () {
        if (opts.onAdded) opts.onAdded();
        return Promise.all([fly(opts.src, opts.rect), Cart.get()]);
      }).then(function (all) {
        Drawer.render(all[1], key); sync();
        if (opts.redirect) { location.href = opts.redirect; return; }
        setTimeout(function () { Drawer.show(); }, 120);
        setTimeout(function () { setBtn(''); if (opts.card) opts.card.classList.remove('is-busy'); }, 900);
      });
    }).catch(function (e) {
      setBtn('');
      if (opts.card) opts.card.classList.remove('is-busy');
      var msg = (e && (e.description || e.message)) || 'Could not add to bag. Please try again.';
      if (opts.onError) opts.onError(msg); else alert(msg);
    });
  }

  /* ---------- quick-add sheet ---------- */
  var Sheet = {
    el: null, data: null, sel: -1, isOpen: false, fromDrawer: false,
    init: function () {
      this.el = $('#NoirSheet'); if (!this.el) return;
      var self = this;
      this.el.addEventListener('click', function (e) {
        if (e.target.closest('[data-ns-close]')) { self.hide(); return; }
        var s = e.target.closest('[data-ns-i]');
        if (s && !s.disabled) { self.pick(Number(s.getAttribute('data-ns-i'))); return; }
        if (e.target.closest('[data-ns-add]')) self.add();
      });
      var panel = $('.ns-panel', this.el), y0 = null, dy = 0;
      panel.addEventListener('touchstart', function (e) { if (panel.scrollTop > 0) return; y0 = e.touches[0].clientY; dy = 0; panel.style.transition = 'none'; }, { passive: true });
      panel.addEventListener('touchmove', function (e) { if (y0 == null) return; dy = Math.max(0, e.touches[0].clientY - y0); if (innerWidth < 750) panel.style.transform = 'translateY(' + dy + 'px)'; }, { passive: true });
      panel.addEventListener('touchend', function () { if (y0 == null) return; panel.style.transition = ''; panel.style.transform = ''; if (dy > 90 && innerWidth < 750) self.hide(); y0 = null; });
    },
    open: function (d, card, fromDrawer) {
      if (!this.el || !d) return;
      this.data = d; this.card = card || null; this.fromDrawer = !!fromDrawer; this.sel = -1;
      var el = this.el;
      var img = $('[data-ns-img]', el); img.src = d.img || img.src; img.alt = d.t || '';
      $('[data-ns-cat]', el).textContent = d.cat || '';
      $('[data-ns-name]', el).textContent = d.t || '';
      $('[data-ns-price]', el).innerHTML = '<b>' + money(d.p) + '</b>' + (d.c > d.p ? '<s>' + money(d.c) + '</s>' : '');
      $('[data-ns-link]', el).href = d.u || '#';
      $('[data-ns-err]', el).textContent = '';
      this.chart = chartFor(d.type || d.t);
      var avail = d.v.filter(function (v) { return v[2]; });
      $('[data-ns-sizes]', el).innerHTML = d.v.map(function (v, i) {
        return '<button type="button" class="ns-size" data-ns-i="' + i + '" aria-pressed="false"' + (v[2] ? '' : ' disabled') + '>' + esc(lab(v[1])) + '</button>';
      }).join('');
      if (avail.length === 1) this.sel = d.v.indexOf(avail[0]);
      this.update();
      if (!this.isOpen) { lastFocus = document.activeElement; lock(true); }
      this.isOpen = true;
      el.classList.add('is-open'); el.setAttribute('aria-hidden', 'false');
      setTimeout(function () { var f = $('.ns-size:not([disabled])', el) || $('[data-ns-close]', el); if (f) f.focus({ preventScroll: true }); }, 80);
    },
    hide: function () {
      if (!this.el || !this.isOpen) return;
      this.isOpen = false; lock(false);
      this.el.classList.remove('is-open'); this.el.setAttribute('aria-hidden', 'true');
      if (!this.fromDrawer && lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
    },
    pick: function (i) { this.sel = i; this.update(); },
    update: function () {
      var el = this.el, d = this.data, i = this.sel;
      $$('.ns-size', el).forEach(function (b, k) { b.setAttribute('aria-pressed', k === i ? 'true' : 'false'); });
      var add = $('[data-ns-add]', el);
      add.disabled = i < 0;
      $('[data-ns-label]', el).textContent = i < 0 ? 'Select a size' : 'Add to bag · ' + money(d.p);
      var hint = '';
      if (this.chart) {
        var row = i >= 0 ? rowFor(this.chart, d.v[i][1]) : null;
        var cols = this.chart.cols, u = unitSym(this.chart.unit);
        if (row) hint = cols.slice(1, 3).map(function (c, k) { return c + ' ' + row[k + 1] + u; }).join(' · ');
        else if (this.chart.rows.length) { var a = this.chart.rows[0], z = this.chart.rows[this.chart.rows.length - 1]; hint = (cols[1] || '') + ' ' + lab(a[0]) + ' ' + a[1] + u + ' – ' + lab(z[0]) + ' ' + z[1] + u; }
      }
      $('[data-ns-hint]', el).textContent = hint;
    },
    add: function () {
      var d = this.data, i = this.sel, self = this, el = this.el;
      if (!d || i < 0) return;
      var thumb = $('.ns-thumb', el);
      addFlow(d.v[i][0], {
        btn: $('[data-ns-add]', el), src: d.img, rect: thumb.getBoundingClientRect(),
        onAdded: function () { self.hide(); },
        onError: function (m) { $('[data-ns-err]', el).textContent = m; }
      });
    }
  };

  /* ---------- product cards ---------- */
  function cardData(card) {
    if (card._nq) return card._nq;
    var s = $('script[data-nq-json]', card);
    try { card._nq = JSON.parse(s.textContent); } catch (e) { card._nq = null; }
    return card._nq;
  }
  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-nq-open]');
    if (open) { e.preventDefault(); var card = open.closest('[data-nq-card]'); Sheet.open(cardData(card), card); return; }
    var add = e.target.closest('[data-nq-add]');
    if (add && !add.disabled) {
      e.preventDefault();
      var c = add.closest('[data-nq-card]'), img = c && $('.nq-media img', c);
      addFlow(add.getAttribute('data-nq-add'), {
        btn: add, card: c, src: img ? (img.currentSrc || img.src) : '', rect: img ? img.getBoundingClientRect() : null
      });
    }
  });
  document.addEventListener('mouseover', function (e) {
    var s = e.target.closest && e.target.closest('.nq-size');
    if (!s) return;
    var card = s.closest('[data-nq-card]'), d = cardData(card), hint = $('[data-nq-hint]', card);
    if (!d || !hint) return;
    var ch = chartFor(d.type), row = rowFor(ch, s.getAttribute('data-nq-size'));
    hint.textContent = row ? (ch.cols[1] || 'Chest') + ' ' + row[1] + unitSym(ch.unit) : '';
  });

  /* ---------- hijack theme cart drawer ---------- */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('.js-drawer-open-cart');
    if (!a || !Drawer.el) return;
    e.preventDefault(); e.stopImmediatePropagation();
    Drawer.refresh(); Drawer.show();
  }, true);
  document.addEventListener('ajaxProduct:added', function () { Drawer.refresh('x'); Drawer.show(); });
  function watchThemeDrawer() {
    var td = document.getElementById('CartDrawer'); if (!td || !Drawer.el) return;
    td.classList.add('noir-hidden');
    new MutationObserver(function () {
      if (td.classList.contains('drawer--is-open')) {
        var x = td.querySelector('.js-drawer-close'); if (x) x.click();
        document.documentElement.classList.remove('js-drawer-open', 'js-drawer-open-right');
        document.body.classList.remove('js-drawer-open', 'js-drawer-open-right');
        Drawer.refresh(); Drawer.show();
      }
    }).observe(td, { attributes: true, attributeFilter: ['class'] });
  }
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (Sheet.isOpen) Sheet.hide(); else if (Drawer.open) Drawer.hide();
  });

  /* ---------- homepage: reveal, tabs, heroes ---------- */
  function initReveal(root) {
    var els = $$('[data-nr-reveal]', root);
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window) || cfg.editor) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (x) { if (x.isIntersecting) { x.target.classList.add('is-in'); io.unobserve(x.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (e, i) { e.style.transitionDelay = (i % 4) * 60 + 'ms'; io.observe(e); });
  }
  function initTabs(root) {
    $$('[data-nr-tabs]', root).forEach(function (sec) {
      var tabs = $$('[role="tab"]', sec);
      tabs.forEach(function (t) {
        t.addEventListener('click', function () {
          tabs.forEach(function (o) {
            var on = o === t; o.setAttribute('aria-selected', on ? 'true' : 'false');
            var p = document.getElementById(o.getAttribute('aria-controls')); if (p) { p.hidden = !on; if (on) p.scrollLeft = 0; }
          });
        });
      });
    });
  }
  function initHeroes(root) {
    $$('[data-nr-heroes]', root).forEach(function (sec) {
      if (sec._nr) return; sec._nr = 1;
      var items = $$('.nr-hero__item', sec), imgs = $$('.nr-hero__imgs img', sec), glow = $('[data-nr-glow]', sec), cta = $('[data-nr-cta]', sec), nm = $('[data-nr-cta-name]', sec);
      if (!items.length) return;
      var cur = 0, hold = 0, vis = false, iv = Number(sec.getAttribute('data-interval')) || 3500;
      function set(i) {
        cur = i;
        items.forEach(function (x, k) { x.classList.toggle('is-on', k === i); });
        imgs.forEach(function (x) { x.classList.toggle('is-on', Number(x.getAttribute('data-i')) === i); });
        if (glow) glow.style.background = items[i].getAttribute('data-glow');
        if (cta) cta.href = items[i].href;
        if (nm) nm.textContent = items[i].getAttribute('data-name');
      }
      items.forEach(function (x, k) {
        x.addEventListener('mouseenter', function () { hold = Date.now() + 12000; set(k); });
        x.addEventListener('focus', function () { hold = Date.now() + 12000; set(k); });
        x.addEventListener('click', function (e) {
          if (matchMedia('(hover: none)').matches && cur !== k) { e.preventDefault(); hold = Date.now() + 12000; set(k); }
        });
      });
      if ('IntersectionObserver' in window) new IntersectionObserver(function (en) { vis = en[0].isIntersecting; }).observe(sec); else vis = true;
      if (!reduce) setInterval(function () { if (vis && Date.now() > hold && !document.hidden) set((cur + 1) % items.length); }, iv);
    });
  }

  /* ---------- product page ---------- */
  function initProduct(sec) {
    if (!sec || sec._np) return; sec._np = 1;
    var data; try { data = JSON.parse($('script[data-np-json]', sec).textContent); } catch (e) { return; }
    var form = $('form.np-form', sec) || $('form[action*="/cart/add"]', sec);
    var idInput = $('[data-np-id]', sec), atc = $('[data-np-atc]', sec), buy = $('[data-np-buy]', sec), err = $('[data-np-err]', sec);
    var groups = $$('[data-np-opt]', sec);
    var chart = chartFor(sec.getAttribute('data-type'));
    var si = parseInt(sec.getAttribute('data-si'), 10) || 0;
    var unit = chart ? chart.unit : 'in';
    var sel = groups.map(function (g) { var on = $('.np-pill[aria-checked="true"]', g); return on ? on.getAttribute('data-value') : null; });
    var variant = null;
    function find() {
      if (!groups.length) return data.v[0] || null;
      return data.v.filter(function (v) { return v.o.every(function (o, i) { return sel[i] == null || o === sel[i]; }); })[0] || null;
    }
    function moveInd(g) {
      var ind = $('.np-ind', g), on = $('.np-pill[aria-checked="true"]', g);
      if (!ind) return;
      if (!on) { ind.classList.remove('is-on'); return; }
      ind.style.width = on.offsetWidth + 'px';
      ind.style.transform = 'translate(' + (on.offsetLeft - 5) + 'px,' + (on.offsetTop - 5) + 'px)';
      ind.classList.add('is-on');
    }
    function markAvail() {
      groups.forEach(function (g, gi) {
        $$('.np-pill', g).forEach(function (p) {
          var val = p.getAttribute('data-value');
          var ok = data.v.some(function (v) { return v.a && v.o[gi] === val && v.o.every(function (o, k) { return k === gi || sel[k] == null || o === sel[k]; }); });
          p.classList.toggle('is-out', !ok);
        });
      });
    }
    function renderMeas() {
      var box = $('[data-np-meas]', sec); if (!box) return;
      var row = chart && variant ? rowFor(chart, variant.o[si]) : null;
      if (!row) { box.hidden = true; return; }
      var u = unitSym(unit);
      box.innerHTML = chart.cols.slice(1, 4).map(function (c, k) { return row[k + 1] ? '<div><b>' + esc(conv(row[k + 1], chart.unit, unit)) + u + '</b><span>' + esc(c) + '</span></div>' : ''; }).join('');
      box.hidden = false;
    }
    function renderChart() {
      var box = $('[data-np-chart]', sec), fb = $('[data-np-chart-fallback]', sec);
      if (!chart) { if (fb) fb.hidden = false; return; }
      var u = unit === 'cm' ? 'CM' : 'IN';
      var cur = variant ? lab(variant.o[si]) : '';
      box.innerHTML = '<div class="np-unit" role="group" aria-label="Units"><button type="button" data-u="in" aria-pressed="' + (unit === 'in') + '">IN</button><button type="button" data-u="cm" aria-pressed="' + (unit === 'cm') + '">CM</button></div>' +
        '<table><thead><tr>' + chart.cols.map(function (c, k) { return '<th>' + esc(c) + (k ? ' (' + u + ')' : '') + '</th>'; }).join('') + '</tr></thead><tbody>' +
        chart.rows.map(function (r) { return '<tr' + (lab(r[0]) === cur ? ' class="is-on"' : '') + '>' + r.map(function (c, k) { return '<td>' + esc(k ? conv(c, chart.unit, unit) : lab(c)) + '</td>'; }).join('') + '</tr>'; }).join('') + '</tbody></table>';
    }
    sec.addEventListener('click', function (e) {
      var ub = e.target.closest('.np-unit button');
      if (ub) { unit = ub.getAttribute('data-u'); renderChart(); renderMeas(); }
    });
    function update(push) {
      variant = find();
      markAvail();
      groups.forEach(moveInd);
      var s0 = $('[data-np-sel-0]', sec); if (s0) s0.textContent = lab(sel[0] || '');
      var ok = variant && variant.a;
      if (variant) {
        idInput.value = variant.id;
        $('[data-np-price]', sec).textContent = money(variant.p);
        $('[data-np-compare]', sec).textContent = variant.c > variant.p ? money(variant.c) : '';
        var off = variant.c > variant.p ? Math.round((variant.c - variant.p) * 100 / variant.c) : 0;
        var sv = $('[data-np-save]', sec); sv.hidden = !off; sv.textContent = 'Save ' + off + '%';
        var bd = $('[data-np-badge]', sec); if (bd) { bd.hidden = !off; bd.textContent = '-' + off + '%'; }
        $('[data-np-sticky-price]', sec).textContent = money(variant.p);
        if (push && history.replaceState) { var u = new URL(location.href); u.searchParams.set('variant', variant.id); history.replaceState(null, '', u.toString()); }
        if (push && variant.m) { var sl = $('.np-slide[data-media-id="' + variant.m + '"]', sec), tr = $('[data-np-track]', sec); if (sl && tr && tr.scrollWidth > tr.clientWidth) tr.scrollTo({ left: sl.offsetLeft, behavior: reduce ? 'auto' : 'smooth' }); }
      }
      atc.disabled = !ok; if (buy) buy.disabled = !ok;
      $('[data-np-atc-label]', sec).textContent = !variant ? 'Unavailable' : (ok ? 'Add to bag · ' + money(variant.p) : 'Sold out');
      var ss = $('[data-np-sticky-size]', sec); if (ss) ss.textContent = variant && groups.length ? '· ' + lab(variant.o[si]) : '';
      renderMeas(); renderChart();
    }
    groups.forEach(function (g, gi) {
      g.addEventListener('click', function (e) {
        var p = e.target.closest('.np-pill'); if (!p) return;
        $$('.np-pill', g).forEach(function (x) { x.setAttribute('aria-checked', x === p ? 'true' : 'false'); });
        sel[gi] = p.getAttribute('data-value'); err.textContent = '';
        update(true);
      });
    });
    window.addEventListener('resize', function () { groups.forEach(moveInd); });
    function go(redirect) {
      if (!variant || !variant.a) return;
      var img = $('.np-slide img', sec);
      addFlow(variant.id, {
        btn: atc, src: data.img, rect: img ? img.getBoundingClientRect() : null,
        redirect: redirect ? ROOT + 'checkout' : null, onError: function (m) { err.textContent = m; }
      });
    }
    if (form) form.addEventListener('submit', function (e) { e.preventDefault(); go(false); });
    if (buy) buy.addEventListener('click', function () { go(true); });
    var sb = $('[data-np-sticky-btn]', sec);
    if (sb) sb.addEventListener('click', function () {
      if (variant && variant.a) { go(false); return; }
      atc.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
    });
    var guide = $('[data-np-guide]', sec);
    if (guide) guide.addEventListener('click', function () { var t = $('[data-np-tab="1"]', sec); t.click(); t.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' }); });
    var ptabs = $$('[data-np-tab]', sec);
    ptabs.forEach(function (t) {
      t.addEventListener('click', function () {
        ptabs.forEach(function (o) { var on = o === t; o.setAttribute('aria-selected', on ? 'true' : 'false'); var p = document.getElementById(o.getAttribute('aria-controls')); if (p) p.hidden = !on; });
      });
    });
    var ship = $('[data-np-ship]', sec), bar = $('[data-np-bar]', sec);
    function shipLine(c) {
      var sub = (c && c.total_price) || 0, left = Math.max(0, FREE - sub);
      ship.innerHTML = left > 0 ? (sub ? 'Add <b>' + money(left) + '</b> more for <b>FREE shipping</b>' : 'Free shipping on orders over <b>' + money(FREE) + '</b>') : 'Your order ships <b>FREE</b>';
      bar.style.width = Math.min(100, sub / FREE * 100) + '%';
    }
    shipLine(Cart.state); document.addEventListener('noir:cart', function (e) { shipLine(e.detail); });
    var clock = $('[data-np-clock]', sec);
    function tick() {
      var now = new Date(), pk = new Date(now.getTime() + (now.getTimezoneOffset() + 300) * 60000);
      var cut = new Date(pk); cut.setHours(14, 0, 0, 0);
      var day = pk.getDay();
      if (day !== 0 && pk < cut) {
        var m = Math.floor((cut - pk) / 60000), h = Math.floor(m / 60);
        clock.innerHTML = 'Order within <b>' + (h ? h + 'h ' : '') + (m % 60) + 'm</b> for <b>same-day dispatch</b>';
      } else clock.innerHTML = 'Order now — <b>dispatched ' + (day === 6 || day === 0 ? 'Monday' : 'tomorrow') + '</b>';
    }
    tick(); setInterval(tick, 30000);
    var track = $('[data-np-track]', sec), dots = $$('.np-dots i', sec);
    if (track && dots.length) {
      var raf = 0;
      track.addEventListener('scroll', function () {
        if (raf) return; raf = requestAnimationFrame(function () { raf = 0; var i = Math.round(track.scrollLeft / track.clientWidth); dots.forEach(function (d, k) { d.classList.toggle('is-on', k === i); }); });
      }, { passive: true });
    }
    var sticky = $('[data-np-sticky]', sec);
    if (sticky && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (en) {
        var r = en[0]; var on = !r.isIntersecting && r.boundingClientRect.top < 0;
        sticky.classList.toggle('is-on', on); sticky.setAttribute('aria-hidden', on ? 'false' : 'true');
        if (sb) sb.tabIndex = on ? 0 : -1;
      }).observe(atc);
    }
    update(false);
    requestAnimationFrame(function () { groups.forEach(moveInd); });
  }

  /* ---------- boot ---------- */
  function boot(root) {
    initReveal(root); initTabs(root); initHeroes(root);
    $$('[data-np]', root).forEach(initProduct);
  }
  var origRender = Drawer.render;
  Drawer.render = function (c, k) { origRender.call(Drawer, c, k); try { document.dispatchEvent(new CustomEvent('noir:cart', { detail: c })); } catch (e) {} };
  function start() {
    Drawer.init(); Sheet.init();
    watchThemeDrawer();
    boot(document);
    Drawer.refresh();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });

  window.Noir = { cart: Cart, drawer: Drawer, sheet: Sheet, add: addFlow, money: money };
})();
